module.exports = __webpack_public_path__ + "assets/content-copy.fbd86cb9.svg";